import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/Logos/w-logo.png";
import servicesData from "../User/Service/Servicesdata.json";

const navItems = [
  { label: "HOME", hasDropdown: false, path: "/" },
  { label: "ABOUT US", hasDropdown: false, path: "/about" },
  {
    label: "SERVICES",
    hasDropdown: true,
    options: servicesData.map((s) => ({ lable: s.lable, slug: s.slug })),
  },
  { label: "PORTFOLIO", hasDropdown: false, path: "/portfolio" },
  { label: "CONTACT US", hasDropdown: false, path: "/contact" },
];

const ChevronDown = ({ open }) => (
  <svg
    className={`inline-block ml-1 w-3 h-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
    fill="none"
    stroke="currentColor"
    strokeWidth={2.5}
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.61 21 3 13.39 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z" />
  </svg>
);

const PinIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

const BottomNavbar = () => {
  const [activeItem, setActiveItem] = useState("HOME");
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // FIX: was undefined
  const menuRef = useRef(null); // FIX: was undefined
  const navigate = useNavigate();

  // FIX: Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavClick = (item) => {
    setActiveItem(item.label);
    if (item.path) {
      navigate(item.path);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleDropdownToggle = (index, item) => {
    if (item.hasDropdown) {
      // FIX: toggle dropdown, don't navigate
      setActiveDropdown(activeDropdown === index ? null : index);
    } else {
      setActiveDropdown(null);
      handleNavClick(item);
    }
  };

  return (
    <div className="w-full font-krona relative">
      {/* ── Top bar ── */}
      <div className="w-full px-6 md:px-8 lg:px-12 pt-4 py-8 lg:pb-12 flex items-center justify-between bg-black">
        <img
          onClick={() => {
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          src={logo}
          alt="Logo"
          className="w-40 h-auto object-cover cursor-pointer"
        />

        <div className="hidden lg:flex items-center gap-8">
          <div className="flex items-center gap-2 text-gray-300 text-sm">
            <span className="text-[#e8341c]">
              <PinIcon />
            </span>
            <span>
              Address: AH45, Shreekhetra Vihar, Khandagiri, Odisha 751019
            </span>
          </div>
          <div className="w-px h-5 bg-gray-600" />
          <div className="flex items-center gap-2 text-sm">
            <span className="text-gray-300">
              <PhoneIcon />
            </span>
            <span className="text-gray-300">Call Us:</span>
            <span className="text-[#e8341c] font-semibold tracking-wide">
              +91 977 777 4005
            </span>
          </div>
        </div>

        {/* Mobile hamburger */}
        <button
          className="lg:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* ── Bottom nav bar ── */}
      <div className="w-full px-4 pb-3 absolute top-20" ref={menuRef}>
        <div className="w-full bg-white rounded-lg hidden lg:flex items-center justify-between px-6 py-4 shadow-md max-w-7xl mx-auto relative">
          {/* Nav links */}
          <nav className="flex items-center gap-1">
            {navItems.map((item, index) => (
              <div key={item.label} className="relative">
                <button
                  onClick={() => handleDropdownToggle(index, item)}
                  className={`flex items-center px-3 py-2 text-sm font-krona font-bold tracking-wider transition-colors duration-150 rounded
                    ${activeItem === item.label ? "text-[#e8341c]" : "text-gray-800 hover:text-[#e8341c]"}`}
                  style={{ fontSize: "0.78rem" }}
                >
                  {item.label}
                  {item.hasDropdown && (
                    <ChevronDown open={activeDropdown === index} />
                  )}
                </button>

                {item.options && activeDropdown === index && (
                  <>
                    {/* Mega Panel */}
                    <div
                      className="absolute left-60 -translate-x-1/2 z-50"
                      style={{
                        top: "calc(100% + 16px)",
                        minWidth: "680px",
                        animation:
                          "appleDropdownIn 0.3s cubic-bezier(0.4,0,0.2,1) forwards",
                      }}
                    >
                      <div
                        className="rounded-2xl border border-white/10 shadow-2xl px-8 py-6"
                        style={{
                          backgroundColor: "rgba(18,18,18,0.95)",
                          backdropFilter: "saturate(180%) blur(20px)",
                          WebkitBackdropFilter: "saturate(180%) blur(20px)",
                        }}
                      >
                        {/* FIX: options use `lable` (matching your data key) */}
                        <div className="grid grid-cols-3 gap-x-10 gap-y-4">
                          {item.options.map((opt, idx) => (
                            <div
                              key={idx}
                              className="group cursor-pointer font-krona"
                              style={{
                                animation: "appleItemIn 0.25s ease forwards",
                                animationDelay: `${idx * 30}ms`,
                                opacity: 0,
                              }}
                              onClick={() => {
                                setActiveDropdown(null);
                                if (opt.slug) navigate(`/services/${opt.slug}`);
                                window.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });
                              }}
                            >
                              <p className="text-[13px] text-zinc-200 group-hover:text-white transition-colors duration-150 font-medium leading-snug">
                                {opt.lable}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <style>{`
                      @keyframes appleDropdownIn {
                        from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
                        to   { opacity: 1; transform: translateX(-50%) translateY(0); }
                      }
                      @keyframes appleItemIn {
                        from { opacity: 0; transform: translateY(5px); }
                        to   { opacity: 1; transform: translateY(0); }
                      }
                    `}</style>
                  </>
                )}
              </div>
            ))}
          </nav>

          {/* Inquiry button */}
          <button
            onClick={() => {
              navigate("/contact");
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
            className="ml-auto bg-[#e8341c] hover:bg-[#c42b14] text-white text-xs font-bold tracking-widest px-6 py-3 rounded transition-colors duration-200 uppercase"
            style={{
              fontFamily: "'Barlow', 'Montserrat', sans-serif",
              letterSpacing: "0.12em",
            }}
          >
            INQUIRY NOW
          </button>
        </div>

        {/* ── Mobile nav ── */}
        {menuOpen && (
          <div className="lg:hidden bg-white rounded-lg mt-2 px-4 py-3 shadow-md flex flex-col gap-2">
            {navItems.map((item) => (
              <div key={item.label}>
                <button
                  onClick={() => {
                    if (item.hasDropdown) {
                      setActiveDropdown(
                        activeDropdown === item.label ? null : item.label,
                      );
                    } else {
                      handleNavClick(item);
                      setMenuOpen(false);
                    }
                  }}
                  className={`flex items-center justify-between w-full px-2 py-2 text-sm font-bold tracking-wider border-b border-gray-100 last:border-0
                    ${activeItem === item.label ? "text-[#e8341c]" : "text-gray-800 hover:text-[#e8341c]"}`}
                >
                  {item.label}
                  {item.hasDropdown && (
                    <ChevronDown open={activeDropdown === item.label} />
                  )}
                </button>

                {/* Mobile dropdown options */}
                {item.options && activeDropdown === item.label && (
                  <div className="pl-4 flex flex-col gap-2 py-2">
                    {item.options.map((opt, idx) => (
                      <button
                        key={idx}
                        className="text-sm text-gray-600 hover:text-[#e8341c] text-left py-1"
                        onClick={() => {
                          setActiveDropdown(null);
                          setMenuOpen(false);
                          if (opt.slug) navigate(`/services/${opt.slug}`);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                      >
                        {opt.lable}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <button
              onClick={() => {
                navigate("/contact");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              className="mt-2 bg-[#e8341c] text-white text-xs font-bold tracking-widest px-6 py-3 rounded uppercase w-full"
            >
              INQUIRY NOW
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomNavbar;
